import Repository from '@/repositories/marketing'
const feedResource = '/product_feeds'

export default {
  /**
   * @use Product feeds index UI
   */
  fetch (config) {
    return Repository.get(`${feedResource}.json`, config)
  },
  /**
   * @use Product feeds drawer START
   */
  update (feedId, data, config) {
    return Repository.put(`${feedResource}/${feedId}.json`, data, config)
  },
  create (data, config) {
    return Repository.post(`${feedResource}.json`, data, config)
  },
  show (feedId,contactId, config) {
    if(contactId !== null)
      return Repository.get(`${feedResource}/${feedId}.json?contact_id=${contactId}`, config)
    else
      return Repository.get(`${feedResource}/${feedId}.json`, config)
  },
  fetchCategories (config) {
    return Repository.get(`${feedResource}/product_categories.json`, config)
  }
  /**
   * @use Product feeds drawer END
   */
}
